var map = {
	"./2022-02-01-2022-03-31": 561,
	"./2022-02-01-2022-03-31.json": 561,
	"./2022-03-31-ru-advances": 963,
	"./2022-03-31-ru-advances.json": 963,
	"./2022-03-31-ru-controlled": 438,
	"./2022-03-31-ru-controlled.json": 438,
	"./2022-04-01-2022-04-30": 691,
	"./2022-04-01-2022-04-30.json": 691,
	"./2022-05-01-2022-05-31": 370,
	"./2022-05-01-2022-05-31.json": 370,
	"./2022-05-01-ru-advances": 206,
	"./2022-05-01-ru-advances.json": 206,
	"./2022-05-01-ru-cotrolled": 435,
	"./2022-05-01-ru-cotrolled.json": 435,
	"./2022-05-31-ru-advances": 641,
	"./2022-05-31-ru-advances.json": 641,
	"./2022-05-31-ru-controlled": 664,
	"./2022-05-31-ru-controlled.json": 664,
	"./2022-06-01-2022-06-30": 407,
	"./2022-06-01-2022-06-30.json": 407,
	"./2022-06-27-ru-advances": 569,
	"./2022-06-27-ru-advances.json": 569,
	"./2022-06-27-ru-controlled": 528,
	"./2022-06-27-ru-controlled.json": 528,
	"./civilbuildings": 922,
	"./civilbuildings.json": 922,
	"./country": 92,
	"./country.json": 92,
	"./regions": 995,
	"./regions.json": 995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;